import { Controller, useForm } from "react-hook-form";
import { MenuItem, Select } from "@mui/material";
import { useSelector } from "react-redux";

export default function VentaInfo({ venta, onVentaInfo }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      codigo_pedido: venta.codigo_pedido,
      plataforma_id: venta.plataforma.id,
    },
  });
  const plataformas = useSelector((state) => {
    return state.plataformas;
  });

  const handleSubmitVentaInfo = (data, e) => {
    e.preventDefault();
    onVentaInfo({ ...data, id: venta.id});
  };


  return (
    <form className="form w-100" onSubmit={handleSubmit(handleSubmitVentaInfo)}>
      <div className="form-group">
        <label>Número pedido</label>
        <input
          {...register("codigo_pedido", { required: true })}
          type="text"
          name="codigo_pedido"
          className="form-control"
        />
        <div className="form-invalid">
          {errors.codigo_pedido?.type === "required" &&
            "El número de pedido es obligatorio"}
        </div>
      </div>

      <div className="form-group">
        <label>Plataforma</label>
        <Controller
          id="venta-info-select"
          name="plataforma_id"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              size="small"
              className="form-control"
            >
              {plataformas.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.nombre}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </div>

      <div className="d-flex align-items-center justify-content-end w-100 mt-3">
        <button type="submit" className="btn btn-primary">
          Guardar
        </button>
      </div>
    </form>
  );
}
